import moment from "moment";
import DateTimeFormatter from "@utils/datetime.formatter";

export default {
  methods: {
    validateDateBeforeDueDate(dateToCheck, dueDate) {
      return moment(dateToCheck, "DD MMM YYYY").isSameOrBefore(dueDate);
    },
    validateDateAfterDueDate(dateToCheck, dueDate) {
      return moment(dateToCheck, "DD MMM YYYY").isSameOrAfter(dueDate);
    },
    getEndDateOfFollowingYear() {
      return moment().add(1, "years").endOf("year").format(DateTimeFormatter.formats.dateOnly);
    },
    getAssignmentMaxEndDate() {
      return moment()
        .set("year", 9999)
        .set("month", 11)
        .set("date", 31)
        .format(DateTimeFormatter.formats.dateOnly);
    },
  },
};
